import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  Typography,
  Drawer,
  Dialog,
  DialogBody,
  DialogHeader,
  Radio,
  DialogFooter,
} from "@material-tailwind/react";
import { useParams, useNavigate } from "react-router-dom";
import "../../index.css";
import { RiAddFill, RiEditLine } from "react-icons/ri";
import { IconButton } from "@material-tailwind/react";
import { useConversationContext } from "../../contexts/ConversationContextProvider";

const FlowChatbot = () => {
  const navigate = useNavigate();
  const { chatbotId } = useParams();
  const [nodes, setNodes] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [popup, setPopup] = useState(null);
  const [openTemplateDialog, setOpenTemplateDialog] = useState(false);
  const [templateType, setTemplateType] = useState(null);
  const [currentParentId, setCurrentParentId] = useState(null);
  const [currentButtonLabel, setCurrentButtonLabel] = useState(null);
  const [currentButtonId, setCurrentButtonId] = useState(null);
  const [isButtonLabelChange, setIsButtonLabelChange] = useState(false);
  const defaultLabelText = "Click on the edit icon to change the label text.";

  const { saveChatbot, getUserBotsById } = useConversationContext();

  const addChildNode = (parentId, buttonId, templateType, buttonLabel) => {
    const buttons = parseInt(templateType, 10);
    if (![0, 1, 2, 3].includes(buttons)) {
      alert("Invalid template!");
      return;
    }

    const firstButtonId = `${new Date().getTime()}_first`;
    const secondButtonId = `${new Date().getTime()}_second`;
    const thirdButtonId = `${new Date().getTime()}_third`;

    if (parentId === 1 && nodes.length === 0) {
      const newNode = {
        id: 1,
        label: defaultLabelText,
        buttons: buttons,
        children:
          buttons === 0
            ? {}
            : buttons === 1
            ? {
                [firstButtonId]: {
                  buttonLabel: "First Button",
                  buttonChild: null,
                },
              }
            : buttons === 2
            ? {
                [firstButtonId]: {
                  buttonLabel: "First Button",
                  buttonChild: null,
                },
                [secondButtonId]: {
                  buttonLabel: "Second Button",
                  buttonChild: null,
                },
              }
            : {
                [firstButtonId]: {
                  buttonLabel: "First Button",
                  buttonChild: null,
                },
                [secondButtonId]: {
                  buttonLabel: "Second Button",
                  buttonChild: null,
                },
                [thirdButtonId]: {
                  buttonLabel: "Third Button",
                  buttonChild: null,
                },
              },
      };
      setNodes([newNode]);
      return;
    }

    setNodes((prevNodes) => {
      const newNodes = JSON.parse(JSON.stringify(prevNodes));

      const findAndAddChild = (node) => {
        const nodeId = node?.id || node?.buttonChild?.id;
        if (nodeId === parentId) {
          const newId = new Date().getTime();
          const targetChildren = node?.children || node?.buttonChild?.children;
          targetChildren[buttonId] = {
            buttonLabel: buttonLabel,
            buttonChild: {
              id: newId,
              label: "child name",
              buttons: buttons,
              children:
                buttons === 0
                  ? {}
                  : buttons === 1
                  ? {
                      [firstButtonId]: {
                        buttonLabel: "First Button",
                        buttonChild: null,
                      },
                    }
                  : buttons === 2
                  ? {
                      [firstButtonId]: {
                        buttonLabel: "First Button",
                        buttonChild: null,
                      },
                      [secondButtonId]: {
                        buttonLabel: "Second Button",
                        buttonChild: null,
                      },
                    }
                  : {
                      [firstButtonId]: {
                        buttonLabel: "First Button",
                        buttonChild: null,
                      },
                      [secondButtonId]: {
                        buttonLabel: "Second Button",
                        buttonChild: null,
                      },
                      [thirdButtonId]: {
                        buttonLabel: "Third Button",
                        buttonChild: null,
                      },
                    },
            },
          };
        } else {
          const children = node?.children || node?.buttonChild?.children;
          if (children) {
            Object.values(children).forEach((child) => {
              if (child) findAndAddChild(child);
            });
          }
        }
      };
      newNodes.forEach(findAndAddChild);
      return newNodes;
    });
  };

  const handleSelectTemplate = (parentId, buttonId, buttonLabel) => {
    // console.log("handleSelectTemplate parentId", parentId);
    // console.log("handleSelectTemplate buttonId", buttonId);
    // console.log("handleSelectTemplate buttonLabel", buttonLabel);

    setCurrentButtonId(buttonId);
    setCurrentParentId(parentId);
    setCurrentButtonLabel(buttonLabel);
    setOpenTemplateDialog(true);
  };

  const confirmSelectTemplate = () => {
    addChildNode(
      currentParentId,
      currentButtonId,
      templateType,
      currentButtonLabel
    );
    setOpenTemplateDialog(false);
    setTemplateType(null);
  };

  useEffect(() => {
    if (chatbotId) {
      const fetchChatbotsData = async () => {
        const response = await getUserBotsById(chatbotId);
        setNodes(JSON.parse(response[0]?.botData));
      };

      fetchChatbotsData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatbotId]);

  const renderNode = (node) => (
    <>
      <div
        key={node.id || node?.buttonChild?.id}
        className="flex flex-col items-center mb-4"
      >
        {(node?.label || node?.buttonChild?.label) && (
          <Card className="p-2 border border-green-500 rounded-lg max-w-lg">
            <CardBody>
              <div className="flex flex-col gap-1">
                <div className="text-left mb-2 font-bold flex flex-row ">
                  <span className="max-w-[200px]">
                    {node.label || node?.buttonChild?.label}
                  </span>
                  <RiEditLine
                    size={16}
                    onClick={() => {
                      setPopup({
                        nodeId: node?.id || node?.buttonChild?.id,
                        label: node?.label || node?.buttonChild?.label,
                      });
                      setOpenDrawer(true);
                    }}
                    className="hover:text-wabmBlue transition duration-300 ease-in-out ml-2"
                  />
                </div>
              </div>
              {(node?.buttons || node?.buttonChild?.buttons === 1) && (
                <div className="flex flex-row items-center gap-2">
                  <Button
                    key={
                      Object.keys(
                        node?.children || node?.buttonChild?.children
                      )[0]
                    }
                    variant="outline"
                    onClick={() => {
                      const buttonKey = Object.keys(
                        node?.children || node?.buttonChild?.children
                      )[0];
                      const buttonChildren =
                        node?.children || node?.buttonChild?.children;
                      setPopup({
                        nodeId: buttonKey,
                        label: buttonChildren?.[buttonKey]?.buttonLabel,
                      });
                      setOpenDrawer(true);
                      setIsButtonLabelChange(true);
                    }}
                    className=" border-green-500 text-green-500 hover:bg-green-50"
                  >
                    {
                      (node?.children || node?.buttonChild?.children)[
                        Object.keys(
                          node?.children || node?.buttonChild?.children
                        )[0]
                      ]?.buttonLabel
                    }
                  </Button>
                  <IconButton
                    className="rounded-full w-8 h-8"
                    color="green"
                    onClick={() =>
                      handleSelectTemplate(
                        node?.id || node?.buttonChild?.id,
                        Object.keys(
                          node?.children || node?.buttonChild?.children
                        )[0] || `${new Date().getTime()}_first`,
                        "First Button"
                      )
                    }
                  >
                    <RiAddFill size={15} />
                  </IconButton>
                </div>
              )}
              {(node?.buttons || node?.buttonChild?.buttons === 2) && (
                <div className="flex flex-row items-center gap-2 mt-2">
                  <Button
                    key={
                      Object.keys(
                        node?.children || node?.buttonChild?.children
                      )[1]
                    }
                    variant="outline"
                    onClick={() => {
                      const buttonKey = Object.keys(
                        node?.children || node?.buttonChild?.children
                      )[1];
                      const buttonChildren =
                        node?.children || node?.buttonChild?.children;
                      setPopup({
                        nodeId: buttonKey,
                        label: buttonChildren?.[buttonKey]?.buttonLabel,
                      });
                      setOpenDrawer(true);
                      setIsButtonLabelChange(true);
                    }}
                    className=" border-green-500 text-green-500 hover:bg-green-50"
                  >
                    {
                      (node?.children || node?.buttonChild?.children)[
                        Object.keys(
                          node?.children || node?.buttonChild?.children
                        )[1]
                      ]?.buttonLabel
                    }
                  </Button>
                  <IconButton
                    className="rounded-full w-8 h-8"
                    color="green"
                    onClick={() =>
                      handleSelectTemplate(
                        node?.id || node?.buttonChild?.id,
                        Object.keys(
                          node?.children || node?.buttonChild?.children
                        )[1] || `${new Date().getTime()}_second`,
                        "Second Button"
                      )
                    }
                  >
                    <RiAddFill size={15} />
                  </IconButton>
                </div>
              )}
              {(node?.buttons || node?.buttonChild?.buttons === 3) && (
                <div className="flex flex-row items-center gap-2 mt-2">
                  <Button
                    key={
                      Object.keys(
                        node?.children || node?.buttonChild?.children
                      )[2]
                    }
                    variant="outline"
                    onClick={() => {
                      const buttonKey = Object.keys(
                        node?.children || node?.buttonChild?.children
                      )[2];
                      const buttonChildren =
                        node?.children || node?.buttonChild?.children;
                      setPopup({
                        nodeId: buttonKey,
                        label: buttonChildren?.[buttonKey]?.buttonLabel,
                      });
                      setOpenDrawer(true);
                      setIsButtonLabelChange(true);
                    }}
                    className=" border-green-500 text-green-500 hover:bg-green-50"
                  >
                    {
                      (node?.children || node?.buttonChild?.children)[
                        Object.keys(
                          node?.children || node?.buttonChild?.children
                        )[2]
                      ]?.buttonLabel
                    }
                  </Button>
                  <IconButton
                    className="rounded-full w-8 h-8"
                    color="green"
                    onClick={() =>
                      handleSelectTemplate(
                        node?.id || node?.buttonChild?.id,
                        Object.keys(
                          node?.children || node?.buttonChild?.children
                        )[2] || `${new Date().getTime()}_third`,
                        "Third Button"
                      )
                    }
                  >
                    <RiAddFill size={15} />
                  </IconButton>
                </div>
              )}
            </CardBody>
          </Card>
        )}
        <div className="flex space-x-4 mt-4">
          {(node?.children || node?.buttonChild?.children) &&
            Object.keys(node?.children || node?.buttonChild?.children).map(
              (key) => {
                const nodeChild = node?.children || node?.buttonChild?.children;
                return nodeChild[key] && renderNode(nodeChild[key]);
              }
            )}
        </div>
      </div>
    </>
  );

  const handleSave = (nodeId, newLabel) => {
    const updatedNodes = JSON.parse(JSON.stringify(nodes));
    updateLabelById(updatedNodes[0], nodeId, newLabel);
    setNodes(updatedNodes);
    setOpenDrawer(false);
  };

  const updateLabelById = (obj, id, newLabel) => {
    if (obj) {
      const targetId = obj?.id || obj?.buttonChild?.id;
      if (targetId === id) {
        if (obj.hasOwnProperty("buttonChild")) {
          obj.buttonChild.label = newLabel;
        } else {
          obj.label = newLabel;
        }
        return true;
      }
      const targetChildren = obj.children || obj.buttonChild?.children;
      if (targetChildren) {
        for (let child of Object.values(targetChildren)) {
          if (updateLabelById(child, id, newLabel)) {
            return true;
          }
        }
      }
      return false;
    }
    return false;
  };

  const handleSaveButton = (nodeId, newLabel) => {
    const updatedNodes = JSON.parse(JSON.stringify(nodes));
    updateButtonLabelById(updatedNodes[0], nodeId, newLabel);
    setNodes(updatedNodes);
    setOpenDrawer(false);
    setIsButtonLabelChange(false);
  };

  const updateButtonLabelById = (obj, id, newLabel) => {
    if (obj) {
      const updateTree = (node) => {
        if (!node) return null;
        if (node.children) {
          Object.keys(node.children).forEach((childKey) => {
            if (childKey === id) {
              node.children[childKey].buttonLabel = newLabel;
            }
            updateTree(node.children[childKey].buttonChild);
          });
        }
      };
      const newTree = { ...obj };
      updateTree(newTree);
    }
    return false;
  };

  const Popup = ({ nodeId, label, onClose, onSave }) => {
    const [newLabel, setNewLabel] = useState(label);
    const handleSave = () => {
      onSave(nodeId, newLabel);
      onClose();
    };

    useEffect(() => {
      setNewLabel(label);
    }, [label]);

    return (
      <div className="popup flex flex-col gap-2 justify-start">
        <textarea
          className="h-32 border-2 border-solid p-2 w-full"
          value={newLabel}
          onChange={(e) => setNewLabel(e.target.value)}
        />
        <div className="flex flex-row justify-end gap-2">
          <Button
            type="button"
            variant="filled"
            color="green"
            onClick={handleSave}
          >
            Save
          </Button>
          <Button type="button" variant="filled" color="red" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div className="p-4 space-y-5">
      <div className="pb-5 flex flex-col gap-5 border-slate-300 border-b-2">
        <div className="flex gap-5">
          <Button
            type="button"
            variant="gradient"
            color="blue"
            onClick={() => {
              navigate(`/dashboard/chatbots`);
            }}
            className="w-fit"
          >
            ⇐ Back to Chatbots
          </Button>
          <Button
            type="button"
            variant="gradient"
            color="green"
            onClick={() => saveChatbot(nodes, chatbotId)}
          >
            Save Chatbot
          </Button>
        </div>
        <h2 className="font-Montserrat text-xl">Chatbot Designer</h2>
      </div>

      {nodes?.length === 0 ? (
        <Button
          onClick={() => handleSelectTemplate(1, null)}
          className="self-center text-lg"
          variant="outlined"
          color="green"
        >
          Design Chatbot
        </Button>
      ) : (
        <div className="flex justify-center">
          {nodes?.map((node) => renderNode(node))}
        </div>
      )}

      <Drawer
        placement="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        size="30vw"
        className="rounded-t-xl  p-3"
      >
        <div className="flex flex-col">
          <Typography variant="h5" className="pb-2" color="blue-gray">
            Update Label
          </Typography>
          <Popup
            nodeId={popup?.nodeId}
            label={popup?.label}
            onClose={() => {
              setPopup(null);
              setOpenDrawer(false);
            }}
            onSave={isButtonLabelChange ? handleSaveButton : handleSave}
          />
        </div>
      </Drawer>
      <Dialog
        open={openTemplateDialog}
        className="lg:min-w-[25%] lg:w-[25%]"
        handler={() => setOpenTemplateDialog(!openTemplateDialog)}
      >
        <DialogHeader>
          <div className="space-y-1">
            <h3 className="text-lg font-bold text-green-700">
              Select Template to design Chatbot
            </h3>
          </div>
        </DialogHeader>
        <DialogBody>
          <div className="flex flex-col justify-start gap-0">
            <Radio
              color="green"
              className="border-2 border-green-400 text-lg font-bold"
              onChange={() => setTemplateType(1)}
              name="type"
              label={
                <Typography
                  color="blue-gray"
                  className="font-bold text-lg text-blue-gray-400"
                >
                  Text with One Button
                </Typography>
              }
            />
            <Radio
              color="green"
              className="border-2 border-green-400 text-lg font-bold"
              onChange={() => setTemplateType(2)}
              name="type"
              label={
                <Typography
                  color="blue-gray"
                  className="font-bold text-lg text-blue-gray-400"
                >
                  Text with Two Buttons
                </Typography>
              }
            />
            <Radio
              color="green"
              className="border-2 border-green-400 text-lg font-bold"
              onChange={() => setTemplateType(3)}
              name="type"
              label={
                <Typography
                  color="blue-gray"
                  className="font-bold text-lg text-blue-gray-400"
                >
                  Text with Three Buttons
                </Typography>
              }
            />

            <Radio
              color="green"
              className="border-2 border-green-400 text-lg font-bold"
              onChange={() => setTemplateType(0)}
              name="type"
              label={
                <Typography
                  color="blue-gray"
                  className="font-bold text-lg text-blue-gray-400"
                >
                  Only Text
                </Typography>
              }
            />
          </div>
        </DialogBody>
        <DialogFooter>
          <div className="flex flex-row-reverse gap-2">
            <Button
              onClick={() => confirmSelectTemplate()}
              variant="outlined"
              color="green"
            >
              Confirm
            </Button>
          </div>
        </DialogFooter>
      </Dialog>
    </div>
  );
};

export default FlowChatbot;
